module.exports = __webpack_public_path__ + "img/base.1024dd4a.png";